<template>
    <v-dialog
        v-model="showDialog"
        v-if="showDialog"
        persistent
        content-class="medium">
        <v-card class="redirect-popup-txhub">
            <v-flex class="txhub-dialog">
                <v-layout
                    row
                    wrap
                    absolute
                    class="txhub-dialog__cont">
                    <v-flex xs8>
                        <h2>{{communityCommonConstant.transactionHub.TITLE_POPUP}}</h2>
                    </v-flex>
                    <v-flex xs4 mt-1 text-xs-right>
                        <v-btn icon data-qe-id="dialogCloseIcon" @click="showDialog = false">
                            <v-icon size="22">close</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex>
                <v-card-text class="txhub-dialog__message-text txhub-dialog__message-desc-border">
                    {{communityCommonConstant.transactionHub.POPUP_DESC}}
                </v-card-text>
                <v-layout row wrap class="txhub-footer-actions">
                    <v-flex sm8 xs12 mt-2 class="checkbox-dialog" text-xs-left v-if="!isMobileAppBrowser">
                        <v-checkbox v-model="inputValue" :label="communityCommonConstant.transactionHub.POPUP_LABEL"></v-checkbox>
                    </v-flex>
                    <v-flex sm4 xs12 text-sm-right text-xs-right class="continue_btn_cookie">
                        <v-btn class="primary_btn" dark
                            data-qe-id="open_Oppurtunity_Page"
                            @click="openOpportunityPage()">
                            {{appCommonConstants.CONTINUE}}
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-card>
    </v-dialog>
</template>

<script>
import { appCommonConstants } from "../../appCommon.constants";
import { communityCommonConstant, setCookie } from "../communityCommon.constant";
import { mapGetters } from 'vuex';
import { storeGetters } from "../../../store/storeGetters.constant";

export default {
    name: 'TransactionHubDialog',
    data: () => ({
            appCommonConstants,
            communityCommonConstant,
            inputValue: false,
        }),
    props: {
        value: {
            type: Boolean,
        },
    },
    methods: {
        setCookie() {
            setCookie('TransactionHubAcknowledgement', true, 180);
        },
        openOpportunityPage() {
            if (this.inputValue === true) {
                this.setCookie();  
            }
            window.open(communityCommonConstant.transactionHub.OPPORTUNITY_URL, this.isMobileAppBrowser ? "_self" : "_blank");
            this.showDialog = false;
        },
    },
    computed: {
        ...mapGetters({
            isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
        }),
        showDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
};
</script>

<style lang="scss">
    @import "../../../common/styles/_colors.scss";
    @import "../../../common/styles/responsive.scss";

    .redirect-popup-txhub {
        .txhub-dialog {
            position: relative;
            background: $ypo-open-blue-gray;
            min-height: 60px;

            h2 {
                color: $ypo-blue;
                margin: 15px 0 0 20px;
                font-size: 20px;
                font-weight: lighter;
            }

            &__cont {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                text-align: left;
            }
            
            &__message-text {
                font-weight: lighter;
                color: $ypo-gray-text;
                text-align: left;
                background-color: $white;
                font-size: 14px;
            }

            &__message-desc-border {
                border-bottom: 1px solid $ypo-duskblue;
            }
        }
        .v-card {
            &__text {
                padding: 16px !important;
            }
        }
        .txhub-footer-actions {
            padding: 10px;
            .checkbox-dialog {
                .v-label {
                    font-size: 14px;
                    font-weight: normal;
                }
                .v-input__slot {
                    margin-bottom: 0;
                    @include breakpoint(xs) {
                        align-items: flex-start;
                    }
                }
                @include breakpoint(xs) {
                    & + .continue_btn_cookie {
                        text-align: left !important;
                    }
                }
            }
        }
    }
</style>
